import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog"
import { IconX } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"
import { useScreenOrientation } from "@/hooks/use-screen-orientation"

interface VideoDialogProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

const VideoDialog = ({ isOpen, onClose, videoUrl }: VideoDialogProps) => {
  const isPortrait = useScreenOrientation();
  const isShort = videoUrl.includes('shorts');

  // Extract video ID from YouTube URL
  const videoId = isShort
    ? videoUrl.split('/shorts/')[1]
    : videoUrl.split('v=')[1];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className={`max-w-[90vw] sm:max-w-[800px] md:max-w-[1000px] p-0 bg-black border-none ${
          isPortrait ? 'max-w-[100vh] !h-[85vh]' : ''
        }`}
      >
        <Button
          variant="ghost"
          size="icon"
          className="absolute -top-12 right-0 text-white z-50 rounded-full bg-white/20 hover:bg-white/80 mx-4"
          onClick={onClose}
        >
          <IconX className="h-8 w-8" />
        </Button>
        <div className={`w-full ${isPortrait ? 'h-full' : 'aspect-video'}`}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1${isShort ? '&rel=0' : ''}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={isPortrait ? 'h-full' : ''}
          ></iframe>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default VideoDialog